import { useEffect } from 'react';

import type { FieldValues, UseFormWatch } from 'react-hook-form';
import { change, initialize } from 'redux-form';

import { storeDispatch } from '../iwProvider/configureStore';

/**
 * Temporary bridge for the redux-form → react-hook-form migration.
 * Mirrors RHF values into `state.form.<formName>.values` so existing
 * sagas/selectors (`formValueSelector`, `getFormValues`) keep working
 * while consumers are migrated off redux-form one by one.
 *
 * Delete the call site once all consumers of `formName` have moved
 * off the redux-form slice.
 */
export const useFormReduxBridge = <T extends FieldValues>(
    formName: string,
    watch: UseFormWatch<T>
) => {
    useEffect(() => {
        storeDispatch(initialize(formName, watch()));

        const subscription = watch((values, { name }) => {
            if (!name) return;
            storeDispatch(
                change(
                    formName,
                    name,
                    (values as Record<string, unknown>)[name]
                )
            );
        });

        return () => subscription.unsubscribe();
    }, [formName, watch]);
};
